var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 724 465",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M722,173C722,168.585 718.415,165 714,165L8,165C3.585,165 0,168.585 0,173L0,505C0,509.415 3.585,513 8,513L714,513C718.415,513 722,509.415 722,505L722,173Z",
    style: {
      fill: "rgb(164,150,252)",
      fillOpacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,279L633,279L633,513L8,513C3.582,513 0,509.418 0,505L0,279Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92,118.224C8.363,118.224 6.955,117.957 5.696,117.424C4.459,116.891 3.477,116.123 2.752,115.12C2.027,114.117 1.653,112.933 1.632,111.568L6.432,111.568C6.496,112.485 6.816,113.211 7.392,113.744C7.989,114.277 8.8,114.544 9.824,114.544C10.869,114.544 11.691,114.299 12.288,113.808C12.885,113.296 13.184,112.635 13.184,111.824C13.184,111.163 12.981,110.619 12.576,110.192C12.171,109.765 11.659,109.435 11.04,109.2C10.443,108.944 9.611,108.667 8.544,108.368C7.093,107.941 5.909,107.525 4.992,107.12C4.096,106.693 3.317,106.064 2.656,105.232C2.016,104.379 1.696,103.248 1.696,101.84C1.696,100.517 2.027,99.365 2.688,98.384C3.349,97.403 4.277,96.656 5.472,96.144C6.667,95.611 8.032,95.344 9.568,95.344C11.872,95.344 13.739,95.909 15.168,97.04C16.619,98.149 17.419,99.707 17.568,101.712L12.64,101.712C12.597,100.944 12.267,100.315 11.648,99.824C11.051,99.312 10.251,99.056 9.248,99.056C8.373,99.056 7.669,99.28 7.136,99.728C6.624,100.176 6.368,100.827 6.368,101.68C6.368,102.277 6.56,102.779 6.944,103.184C7.349,103.568 7.84,103.888 8.416,104.144C9.013,104.379 9.845,104.656 10.912,104.976C12.363,105.403 13.547,105.829 14.464,106.256C15.381,106.683 16.171,107.323 16.832,108.176C17.493,109.029 17.824,110.149 17.824,111.536C17.824,112.731 17.515,113.84 16.896,114.864C16.277,115.888 15.371,116.709 14.176,117.328C12.981,117.925 11.563,118.224 9.92,118.224ZM26.924,103.952L26.924,112.528C26.924,113.125 27.063,113.563 27.34,113.84C27.639,114.096 28.129,114.224 28.812,114.224L30.892,114.224L30.892,118L28.076,118C24.3,118 22.412,116.165 22.412,112.496L22.412,103.952L20.3,103.952L20.3,100.272L22.412,100.272L22.412,95.888L26.924,95.888L26.924,100.272L30.892,100.272L30.892,103.952L26.924,103.952ZM50.85,100.272L50.85,118L46.338,118L46.338,115.76C45.762,116.528 45.005,117.136 44.066,117.584C43.149,118.011 42.146,118.224 41.058,118.224C39.672,118.224 38.445,117.936 37.378,117.36C36.312,116.763 35.469,115.899 34.85,114.768C34.253,113.616 33.954,112.251 33.954,110.672L33.954,100.272L38.434,100.272L38.434,110.032C38.434,111.44 38.786,112.528 39.49,113.296C40.194,114.043 41.154,114.416 42.37,114.416C43.608,114.416 44.578,114.043 45.282,113.296C45.986,112.528 46.338,111.44 46.338,110.032L46.338,100.272L50.85,100.272ZM54.118,109.072C54.118,107.28 54.471,105.691 55.175,104.304C55.9,102.917 56.881,101.851 58.118,101.104C59.356,100.357 60.732,99.984 62.246,99.984C63.399,99.984 64.497,100.24 65.543,100.752C66.588,101.243 67.42,101.904 68.039,102.736L68.039,94.32L72.583,94.32L72.583,118L68.039,118L68.039,115.376C67.484,116.251 66.705,116.955 65.703,117.488C64.7,118.021 63.537,118.288 62.215,118.288C60.721,118.288 59.356,117.904 58.118,117.136C56.881,116.368 55.9,115.291 55.175,113.904C54.471,112.496 54.118,110.885 54.118,109.072ZM68.071,109.136C68.071,108.048 67.857,107.12 67.431,106.352C67.004,105.563 66.428,104.965 65.703,104.56C64.977,104.133 64.198,103.92 63.367,103.92C62.535,103.92 61.767,104.123 61.063,104.528C60.359,104.933 59.783,105.531 59.335,106.32C58.908,107.088 58.695,108.005 58.695,109.072C58.695,110.139 58.908,111.077 59.335,111.888C59.783,112.677 60.359,113.285 61.063,113.712C61.788,114.139 62.556,114.352 63.367,114.352C64.198,114.352 64.977,114.149 65.703,113.744C66.428,113.317 67.004,112.72 67.431,111.952C67.857,111.163 68.071,110.224 68.071,109.136ZM93.438,108.752C93.438,109.392 93.395,109.968 93.31,110.48L80.35,110.48C80.457,111.76 80.905,112.763 81.694,113.488C82.483,114.213 83.454,114.576 84.606,114.576C86.27,114.576 87.454,113.861 88.158,112.432L92.99,112.432C92.478,114.139 91.497,115.547 90.046,116.656C88.595,117.744 86.814,118.288 84.702,118.288C82.995,118.288 81.459,117.915 80.094,117.168C78.75,116.4 77.694,115.323 76.926,113.936C76.179,112.549 75.806,110.949 75.806,109.136C75.806,107.301 76.179,105.691 76.926,104.304C77.673,102.917 78.718,101.851 80.062,101.104C81.406,100.357 82.953,99.984 84.702,99.984C86.387,99.984 87.891,100.347 89.214,101.072C90.558,101.797 91.593,102.832 92.318,104.176C93.065,105.499 93.438,107.024 93.438,108.752ZM88.798,107.472C88.777,106.32 88.361,105.403 87.55,104.72C86.739,104.016 85.747,103.664 84.574,103.664C83.465,103.664 82.526,104.005 81.758,104.688C81.011,105.349 80.553,106.277 80.382,107.472L88.798,107.472ZM106.532,100.016C108.644,100.016 110.351,100.688 111.652,102.032C112.953,103.355 113.604,105.211 113.604,107.6L113.604,118L109.124,118L109.124,108.208C109.124,106.8 108.772,105.723 108.068,104.976C107.364,104.208 106.404,103.824 105.188,103.824C103.951,103.824 102.969,104.208 102.244,104.976C101.54,105.723 101.188,106.8 101.188,108.208L101.188,118L96.708,118L96.708,100.272L101.188,100.272L101.188,102.48C101.785,101.712 102.543,101.115 103.46,100.688C104.399,100.24 105.423,100.016 106.532,100.016ZM123.08,103.952L123.08,112.528C123.08,113.125 123.219,113.563 123.496,113.84C123.795,114.096 124.286,114.224 124.968,114.224L127.048,114.224L127.048,118L124.232,118C120.456,118 118.568,116.165 118.568,112.496L118.568,103.952L116.456,103.952L116.456,100.272L118.568,100.272L118.568,95.888L123.08,95.888L123.08,100.272L127.048,100.272L127.048,103.952L123.08,103.952ZM136.808,106.8C136.808,104.603 137.298,102.64 138.28,100.912C139.282,99.163 140.637,97.808 142.344,96.848C144.072,95.867 146.002,95.376 148.136,95.376C150.632,95.376 152.818,96.016 154.696,97.296C156.573,98.576 157.885,100.347 158.632,102.608L153.48,102.608C152.968,101.541 152.242,100.741 151.304,100.208C150.386,99.675 149.32,99.408 148.104,99.408C146.802,99.408 145.64,99.717 144.616,100.336C143.613,100.933 142.824,101.787 142.248,102.896C141.693,104.005 141.416,105.307 141.416,106.8C141.416,108.272 141.693,109.573 142.248,110.704C142.824,111.813 143.613,112.677 144.616,113.296C145.64,113.893 146.802,114.192 148.104,114.192C149.32,114.192 150.386,113.925 151.304,113.392C152.242,112.837 152.968,112.027 153.48,110.96L158.632,110.96C157.885,113.243 156.573,115.024 154.696,116.304C152.84,117.563 150.653,118.192 148.136,118.192C146.002,118.192 144.072,117.712 142.344,116.752C140.637,115.771 139.282,114.416 138.28,112.688C137.298,110.96 136.808,108.997 136.808,106.8ZM170.33,118.288C168.623,118.288 167.087,117.915 165.722,117.168C164.357,116.4 163.279,115.323 162.49,113.936C161.722,112.549 161.338,110.949 161.338,109.136C161.338,107.323 161.733,105.723 162.522,104.336C163.333,102.949 164.431,101.883 165.818,101.136C167.205,100.368 168.751,99.984 170.458,99.984C172.165,99.984 173.711,100.368 175.098,101.136C176.485,101.883 177.573,102.949 178.362,104.336C179.173,105.723 179.578,107.323 179.578,109.136C179.578,110.949 179.162,112.549 178.33,113.936C177.519,115.323 176.41,116.4 175.002,117.168C173.615,117.915 172.058,118.288 170.33,118.288ZM170.33,114.384C171.141,114.384 171.898,114.192 172.602,113.808C173.327,113.403 173.903,112.805 174.33,112.016C174.757,111.227 174.97,110.267 174.97,109.136C174.97,107.451 174.522,106.16 173.626,105.264C172.751,104.347 171.674,103.888 170.394,103.888C169.114,103.888 168.037,104.347 167.162,105.264C166.309,106.16 165.882,107.451 165.882,109.136C165.882,110.821 166.298,112.123 167.13,113.04C167.983,113.936 169.05,114.384 170.33,114.384ZM185.136,98.16C184.347,98.16 183.686,97.915 183.152,97.424C182.64,96.912 182.384,96.283 182.384,95.536C182.384,94.789 182.64,94.171 183.152,93.68C183.686,93.168 184.347,92.912 185.136,92.912C185.926,92.912 186.576,93.168 187.088,93.68C187.622,94.171 187.888,94.789 187.888,95.536C187.888,96.283 187.622,96.912 187.088,97.424C186.576,97.915 185.926,98.16 185.136,98.16ZM187.344,100.272L187.344,118L182.864,118L182.864,100.272L187.344,100.272ZM201.595,100.016C203.707,100.016 205.413,100.688 206.715,102.032C208.016,103.355 208.667,105.211 208.667,107.6L208.667,118L204.187,118L204.187,108.208C204.187,106.8 203.835,105.723 203.131,104.976C202.427,104.208 201.467,103.824 200.251,103.824C199.013,103.824 198.032,104.208 197.307,104.976C196.603,105.723 196.251,106.8 196.251,108.208L196.251,118L191.771,118L191.771,100.272L196.251,100.272L196.251,102.48C196.848,101.712 197.605,101.115 198.523,100.688C199.461,100.24 200.485,100.016 201.595,100.016ZM250.408,95.664L244.168,118L238.888,118L234.696,102.096L230.312,118L225.064,118.032L219.048,95.664L223.848,95.664L227.784,113.008L232.328,95.664L237.32,95.664L241.608,112.912L245.576,95.664L250.408,95.664ZM252.181,109.072C252.181,107.28 252.533,105.691 253.237,104.304C253.962,102.917 254.933,101.851 256.149,101.104C257.386,100.357 258.762,99.984 260.277,99.984C261.6,99.984 262.752,100.251 263.733,100.784C264.736,101.317 265.536,101.989 266.133,102.8L266.133,100.272L270.645,100.272L270.645,118L266.133,118L266.133,115.408C265.557,116.24 264.757,116.933 263.733,117.488C262.73,118.021 261.568,118.288 260.245,118.288C258.752,118.288 257.386,117.904 256.149,117.136C254.933,116.368 253.962,115.291 253.237,113.904C252.533,112.496 252.181,110.885 252.181,109.072ZM266.133,109.136C266.133,108.048 265.92,107.12 265.493,106.352C265.066,105.563 264.49,104.965 263.765,104.56C263.04,104.133 262.261,103.92 261.429,103.92C260.597,103.92 259.829,104.123 259.125,104.528C258.421,104.933 257.845,105.531 257.397,106.32C256.97,107.088 256.757,108.005 256.757,109.072C256.757,110.139 256.97,111.077 257.397,111.888C257.845,112.677 258.421,113.285 259.125,113.712C259.85,114.139 260.618,114.352 261.429,114.352C262.261,114.352 263.04,114.149 263.765,113.744C264.49,113.317 265.066,112.72 265.493,111.952C265.92,111.163 266.133,110.224 266.133,109.136ZM279.501,94.32L279.501,118L275.021,118L275.021,94.32L279.501,94.32ZM288.407,94.32L288.407,118L283.927,118L283.927,94.32L288.407,94.32ZM309.313,108.752C309.313,109.392 309.27,109.968 309.185,110.48L296.225,110.48C296.332,111.76 296.78,112.763 297.569,113.488C298.358,114.213 299.329,114.576 300.481,114.576C302.145,114.576 303.329,113.861 304.033,112.432L308.865,112.432C308.353,114.139 307.372,115.547 305.921,116.656C304.47,117.744 302.689,118.288 300.577,118.288C298.87,118.288 297.334,117.915 295.969,117.168C294.625,116.4 293.569,115.323 292.801,113.936C292.054,112.549 291.681,110.949 291.681,109.136C291.681,107.301 292.054,105.691 292.801,104.304C293.548,102.917 294.593,101.851 295.937,101.104C297.281,100.357 298.828,99.984 300.577,99.984C302.262,99.984 303.766,100.347 305.089,101.072C306.433,101.797 307.468,102.832 308.193,104.176C308.94,105.499 309.313,107.024 309.313,108.752ZM304.673,107.472C304.652,106.32 304.236,105.403 303.425,104.72C302.614,104.016 301.622,103.664 300.449,103.664C299.34,103.664 298.401,104.005 297.633,104.688C296.886,105.349 296.428,106.277 296.257,107.472L304.673,107.472ZM317.799,103.952L317.799,112.528C317.799,113.125 317.938,113.563 318.215,113.84C318.514,114.096 319.004,114.224 319.687,114.224L321.767,114.224L321.767,118L318.951,118C315.175,118 313.287,116.165 313.287,112.496L313.287,103.952L311.175,103.952L311.175,100.272L313.287,100.272L313.287,95.888L317.799,95.888L317.799,100.272L321.767,100.272L321.767,103.952L317.799,103.952Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,343.311L235.842,309L322.917,440.57L271.075,474.881L184,343.311Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.129,309.683L535.835,332.713L503.706,491.35L390,468.321L422.129,309.683Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.582,347.394L436.771,340.801",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.586,362.309C444.777,361.053 438.969,359.954 433.003,358.698",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.814,365.291C462.517,364.663 459.22,364.035 455.924,363.25",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.203,383.346C454.511,381.776 446.975,380.206 439.283,378.636",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.046,446.77L449.33,427.931L424.997,432.17L415.106,399.516",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.037,316.938C592.347,316.938 608.046,332.637 608.046,351.947C608.046,371.257 592.347,386.957 573.037,386.957C553.728,386.957 538.029,371.257 538.029,351.947C538.029,329.027 553.728,316.938 573.037,316.938ZM573.037,363.722C579.631,363.722 584.968,358.384 584.968,351.79C584.968,345.197 579.631,339.859 573.037,339.859C566.444,339.859 561.263,343.941 561.263,351.79C561.263,358.541 566.601,363.722 573.037,363.722Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.037,340.016L573.037,316.938",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.968,351.947L608.046,351.947",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.143,344.255L597.998,328.555",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.347,376.124L512.754,372.984L509.614,378.95L519.347,376.124Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,428.981C294,467.758 325.398,499.314 364.331,499.314C382.699,499.314 399.34,492.249 411.899,480.789L380.187,449.076C375.791,452.53 370.297,454.571 364.331,454.571C350.202,454.571 338.742,443.111 338.742,428.981C338.742,422.231 340.626,416.736 343.766,412.654L311.112,380C300.594,391.774 294,408.102 294,428.981Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.097,439.657L297.925,452.216",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.742,428.981L294,428.981",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.576,460.851L389.92,483.929L370.297,489.423L367.314,462.892L376.576,460.851Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,342.947C235,373.247 259.647,397.894 289.946,397.894C320.245,397.894 344.892,373.247 344.892,342.947C344.892,312.648 320.245,288 289.946,288C259.49,288 235,306.839 235,342.947Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.292,296.949L289.946,342.947L235,342.947",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.421,324.597L313.853,358.948L297.193,352.853L309.761,318.502L326.421,324.597Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.572,316.604L299.771,329.726L283.111,323.63L287.912,310.509L304.572,316.604Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.48,319.136C509.018,319.136 504.59,314.708 504.59,309.245C504.59,303.783 509.018,299.355 514.48,299.355C519.943,299.355 524.371,303.783 524.371,309.245C524.371,314.708 519.943,319.136 514.48,319.136Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.874,476.529L464.806,498.668L442.668,504.6L436.736,482.461L458.874,476.529Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.358,452.714L489.176,496.943L467.651,489.068L483.834,444.838L505.358,452.714Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.845,444.441L538.187,473.556L524.058,480.031L510.716,450.916L524.845,444.441Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.292,305.948L397.367,309.245",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.296,418.826L385.279,427.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.743,438.45L371.935,441.59",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.838,305.948L255.763,313.17",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.924,316.938L234.569,322.589",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.797,313.17L538.029,316.938",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.968,410.505L578.375,413.645",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.104,329.382L450.218,368.491L481.774,454.738L588.659,415.63L557.104,329.382Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.984,358.384L545.433,350.063",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.554,362.622L547.003,354.302",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.515,392.137C552.376,392.137 554.696,389.817 554.696,386.956C554.696,384.095 552.376,381.775 549.515,381.775C546.654,381.775 544.335,384.095 544.335,386.956C544.335,389.817 546.654,392.137 549.515,392.137Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.505,433.269L498.494,405.638L507.285,411.918L524.554,376.124",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.554,418.826L522.984,423.221",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.956,494.967L415.106,502.031",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.763,416.785L263.612,421.023",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.477,275.957C381.46,260.88 411.959,241.298 414.732,217.21C418.891,214.611 423.05,212.184 427.209,209.758C432.408,243.724 402.428,266.773 378.167,288.261C368.983,296.406 355.293,284.102 364.477,275.957Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.477,275.957C359.278,280.463 352.693,288.781 353.906,290.168C355.119,291.554 357.026,287.568 358.585,287.568C360.145,287.568 352.347,295.366 353.906,296.926C355.466,298.486 361.011,292.767 361.011,292.767C361.011,292.767 355.466,297.793 357.026,299.179C358.759,300.392 364.651,294.847 364.651,294.847C364.651,294.847 357.719,298.832 360.145,300.565C362.398,302.298 372.969,292.94 377.128,289.474",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.477,275.957C359.278,280.463 352.693,288.781 353.906,290.168C355.119,291.554 357.026,287.568 358.585,287.568C360.145,287.568 352.347,295.366 353.906,296.926C355.466,298.486 361.011,292.767 361.011,292.767C361.011,292.767 355.466,297.793 357.026,299.179C358.759,300.392 364.651,294.847 364.651,294.847C364.651,294.847 357.719,298.832 360.145,300.565C362.398,302.298 372.969,292.94 377.128,289.474",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.91,180.298C485.088,176.832 533.784,125.363 544.354,91.398C548.513,78.227 569.482,82.733 565.496,96.077C551.979,139.4 496.526,197.281 451.123,201.787C437.26,203.346 436.047,181.685 449.91,180.298Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.482,239.912C399.655,240.432 399.829,240.952 400.175,241.471C400.695,242.165 401.215,242.858 401.735,243.378L401.908,243.378C406.067,246.324 409.187,246.67 409.187,246.67L410.053,244.937C410.053,244.937 415.078,244.417 415.252,239.565L424.783,232.98C423.743,230.034 423.223,226.741 422.877,223.449C419.584,225.875 414.905,229.167 412.826,230.727C412.132,231.247 411.786,231.42 411.786,231.42C411.613,231.247 411.266,231.074 411.266,231.074C411.093,230.9 410.919,230.9 410.573,230.727L410.4,230.727C410.226,230.727 410.053,230.554 409.88,230.554C409.533,230.381 409.187,230.381 408.84,230.207L408.147,230.207C407.107,230.034 405.894,230.207 404.508,230.381C402.082,230.727 400.522,232.114 399.655,233.846C399.309,234.366 399.136,235.06 399.136,235.579C398.962,236.966 398.962,238.525 399.482,239.912Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.136,235.579C399.309,235.06 399.482,234.366 399.656,233.846C400.522,232.114 402.082,230.9 404.508,230.381C405.894,230.207 407.107,230.034 408.147,230.207L408.84,230.207C409.187,230.207 409.533,230.381 409.88,230.554C410.053,230.554 410.226,230.727 410.4,230.727L410.573,230.727C410.746,230.9 411.093,230.9 411.266,231.074C411.266,231.074 411.613,231.247 411.786,231.42C411.786,231.42 412.133,231.074 412.826,230.727C412.306,231.767 411.959,232.46 411.786,232.633C411.613,233.327 409.36,236.446 408.84,235.233C408.147,233.846 405.894,233.846 405.721,235.579C405.548,237.312 403.988,241.645 401.908,243.378C401.215,242.858 400.695,242.338 400.349,241.471C400.002,240.952 399.829,240.432 399.656,239.912C398.962,238.525 398.962,236.966 399.136,235.579Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.16,204.56C462.907,193.295 456.842,175.099 442.285,182.031C436.047,185.844 410.4,208.025 419.584,217.21C422.357,219.983 425.476,227.781 429.808,229.341C438.993,232.807 452.856,227.088 449.044,221.716C459.441,210.278 465.16,204.56 465.16,204.56Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.921,184.111C505.537,180.818 553.885,137.321 569.482,105.434C575.547,93.131 595.822,100.755 589.584,113.233C569.655,153.957 521.826,207.505 458.402,208.199C444.538,208.545 439.686,185.497 458.921,184.111Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.474,284.622C398.616,269.718 425.996,249.443 422.357,219.983C420.797,207.679 439.859,204.733 441.419,217.037C445.924,254.295 417.331,278.903 389.778,298.312C379.727,305.417 367.25,291.727 377.474,284.622Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.136,235.579C400.522,226.222 408.84,230.554 411.266,219.81C413.692,209.065 403.988,202.307 408.667,189.656C413.346,177.006 412.999,175.446 412.306,169.034C411.613,162.622 426.169,166.954 424.61,178.392C423.05,189.829 422.703,188.443 428.769,200.054C434.661,211.665 424.263,225.702 411.959,231.42C399.655,237.139 399.136,235.579 399.136,235.579Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.474,284.622C371.756,288.608 364.304,296.06 365.344,297.446C366.383,298.832 368.81,295.193 370.196,295.366C371.755,295.54 363.091,302.298 364.477,304.204C365.864,305.937 371.929,300.912 371.929,300.912C371.929,300.912 365.864,305.418 367.423,306.804C368.983,308.19 375.395,303.338 375.395,303.338C375.395,303.338 368.116,306.631 370.196,308.537C372.275,310.443 383.886,302.298 388.218,299.352",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.474,284.622C371.756,288.608 364.304,296.06 365.344,297.446C366.383,298.832 368.81,295.193 370.196,295.366C371.755,295.54 363.091,302.298 364.477,304.204C365.864,305.937 371.929,300.912 371.929,300.912C371.929,300.912 365.864,305.418 367.423,306.804C368.983,308.19 375.395,303.338 375.395,303.338C375.395,303.338 368.116,306.631 370.196,308.537C372.275,310.443 383.886,302.298 388.218,299.352",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.759,287.395C363.437,286.355 366.903,283.582 366.903,283.582L358.759,287.395Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.759,287.395C363.437,286.355 366.903,283.582 366.903,283.582",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.482,105.435C571.735,101.102 574.334,95.037 575.72,91.571C576.413,89.838 577.973,88.625 579.879,88.105C587.504,86.545 607.259,82.906 608.992,83.946C611.072,85.159 610.032,86.719 610.032,86.719C610.032,86.719 610.379,86.719 610.725,87.932C611.072,89.145 610.205,90.531 610.205,90.531C610.205,90.531 611.765,90.185 612.112,91.918C612.458,93.65 611.245,94.517 611.245,94.517C611.245,94.517 612.458,94.864 612.458,96.423C612.458,97.81 606.913,99.889 600.848,101.969C594.782,104.048 593.223,106.994 589.757,113.406",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.482,105.435C571.735,101.102 574.334,95.037 575.72,91.571C576.413,89.838 577.973,88.625 579.879,88.105C587.504,86.545 607.259,82.906 608.992,83.946C611.072,85.159 610.032,86.719 610.032,86.719C610.032,86.719 610.379,86.719 610.725,87.932C611.072,89.145 610.205,90.531 610.205,90.531C610.205,90.531 611.765,90.185 612.112,91.918C612.458,93.65 611.245,94.517 611.245,94.517C611.245,94.517 612.458,94.864 612.458,96.423C612.458,97.81 606.913,99.889 600.848,101.969C594.782,104.048 593.223,106.994 589.757,113.406",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.339,87.065C606.566,87.758 606.046,87.758 606.046,87.758L609.339,87.065Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.339,87.065C606.566,87.758 606.046,87.758 606.046,87.758",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.968,95.557C544.528,90.878 545.914,84.466 546.781,80.827C547.127,78.92 548.513,77.534 550.246,76.841C557.525,73.895 576.413,67.136 578.146,67.829C580.399,68.696 579.706,70.429 579.706,70.429C579.706,70.429 581.092,70.429 581.612,71.642C582.132,72.855 581.439,74.241 581.439,74.241C581.439,74.241 582.999,73.721 583.518,75.281C584.038,76.841 583.172,77.187 583.172,77.187C583.172,77.187 584.905,78.054 584.731,79.44C584.385,81.693 578.84,83.599 573.121,86.719C567.402,89.838 566.882,91.917 564.456,98.849",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.968,95.557C544.528,90.878 545.914,84.466 546.781,80.827C547.127,78.92 548.513,77.534 550.246,76.841C557.525,73.895 576.413,67.136 578.146,67.829C580.399,68.696 579.706,70.429 579.706,70.429C579.706,70.429 581.092,70.429 581.612,71.642C582.132,72.855 581.439,74.241 581.439,74.241C581.439,74.241 582.999,73.721 583.518,75.281C584.038,76.841 583.172,77.187 583.172,77.187C583.172,77.187 584.905,78.054 584.731,79.44C584.385,81.693 578.84,83.599 573.121,86.719C567.402,89.838 566.882,91.917 564.456,98.849",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.172,77.188C580.572,78.401 579.186,78.921 579.186,78.921L583.172,77.188Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.172,77.188C580.572,78.401 579.186,78.921 579.186,78.921",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.166,184.111L445.751,190.003",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.448,188.963L457.015,212.704",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.942,193.989L452.51,217.73",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.939,218.25C444.365,220.676 446.618,222.929 449.044,225.355L441.939,218.25Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.939,218.25C444.365,220.676 446.618,222.929 449.044,225.355",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.916,200.054C426.862,203 429.808,205.946 432.581,208.892L423.916,200.054Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.916,200.054C426.862,203 429.808,205.946 432.581,208.892",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.885,181.165L449.91,185.324",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.586,529.071L647.586,230.483C647.586,226.497 644.293,223.205 640.307,223.205C636.322,223.205 633.029,226.497 633.029,230.483L633.029,263.756",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.746,529.071L699.746,230.483C699.746,226.497 696.454,223.205 692.468,223.205C688.482,223.205 685.19,226.497 685.19,230.483L685.19,263.756",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.746,264.449L553.315,264.449",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.746,297.202L647.586,297.202",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.746,329.955L647.586,329.955",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.746,362.708L647.586,362.708",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.746,395.287L647.586,395.287",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.54,288.912L237.045,294.978L230.979,305.483L220.475,299.417L226.54,288.912Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.435,280.707L301.767,269.507",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.349,279.872L513.804,282.992",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.098,259.077L459.217,264.969",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.747,287.671L531.653,292.003",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.049,279.872L597.851,285.071",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.192,186.888L568.467,200.146L536.55,246.549L517.276,233.291L549.192,186.888Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.118,
    y: 226.324,
    width: 12.823,
    height: 38.125,
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.135,
    y: 222.858,
    width: 12.824,
    height: 41.764,
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.153,
    y: 235.335,
    width: 12.823,
    height: 29.114,
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.673,471.17L28.666,471.182L28.659,471.194C28.606,471.301 28.482,471.336 28.382,471.278L10.919,461.196C10.805,461.13 10.766,460.976 10.828,460.867L40.547,409.392L40.797,408.959L40.364,408.709L30.989,403.297C30.889,403.239 30.849,403.147 30.864,403.051C30.883,402.933 30.955,402.871 31.033,402.854L31.037,402.853L59.636,396.6C59.712,396.588 59.782,396.603 59.83,396.631C59.877,396.657 59.904,396.692 59.916,396.735L59.919,396.746L59.922,396.756L68.81,424.662L68.811,424.666C68.837,424.744 68.804,424.849 68.736,424.901L68.736,424.901L68.725,424.91C68.649,424.971 68.55,424.983 68.449,424.925L59.075,419.512L58.642,419.262L58.392,419.695L28.673,471.17Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(20,20,43)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.55,459.356L71.087,449.273C70.736,449.071 70.612,448.611 70.814,448.261L100.532,396.787L91.158,391.374C90.885,391.217 90.741,390.926 90.789,390.618C90.837,390.309 91.052,390.071 91.348,390.009L119.948,383.773C120.325,383.706 120.695,383.92 120.806,384.268L129.705,412.154C129.799,412.442 129.689,412.767 129.457,412.943C129.214,413.139 128.891,413.159 128.618,413.002L119.243,407.589L89.524,459.064C89.361,459.436 88.901,459.558 88.55,459.356Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.547,441.366L135.797,440.933L135.364,440.683L125.989,435.27C125.888,435.212 125.849,435.121 125.864,435.024C125.883,434.906 125.954,434.844 126.032,434.827L126.036,434.827L154.625,428.593C154.768,428.571 154.882,428.657 154.91,428.748L154.911,428.749L163.81,456.635L163.811,456.639C163.837,456.717 163.804,456.822 163.736,456.874L163.725,456.883C163.649,456.944 163.55,456.956 163.449,456.898L154.075,451.485L153.642,451.235L153.392,451.668L123.673,503.143L123.659,503.167L123.648,503.192C123.631,503.231 123.599,503.26 123.551,503.274C123.499,503.289 123.437,503.283 123.382,503.252L105.918,493.169C105.805,493.104 105.765,492.949 105.828,492.84L135.547,441.366Z",
    style: {
      fill: "rgb(252,252,252)",
      fillRule: "nonzero",
      stroke: "rgb(20,20,43)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.65335e-15,141.32,-141.32,8.65335e-15,314.642,372.829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(121,75,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(121,75,250)",
      stopOpacity: 0.1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide1);
export default __webpack_public_path__ + "static/media/slide1.2bd36355af40912251e130df86fb77bb.svg";
export { ForwardRef as ReactComponent };